import React, { useEffect } from 'react';
import './styles.scss';
import EditUserProfile from '../../containers/OnBoarding/EditUserProfile';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../actionCreators/auth';
import { logFirebaseEvent } from '../../firebase/analytics';
import { clearStorageOnLogout } from '../../api/helpers';
import { Link } from 'react-router-dom';
import { signout } from '../../utils/msalConfig';

function EditProfileComponent(props) {
  useEffect(() => {
    logFirebaseEvent({
      event: 'profile',
      action: 'load',
    });
  }, []);

  const handleSignOut = async () => {
    const currentUser = props.currentUser

    if (currentUser && currentUser.azure.homeAccountId) {
      signout(currentUser).then(()=> {
        clearStorageOnLogout();
        props.handleLogout();
        window.location.reload();
      })
      .catch((err) => {
        // Handle error
        console.error(err);
      });
    } else {
      clearStorageOnLogout();
      props.handleLogout();
      window.location.reload();
    }
  };

  const isMicrosoftAzureUser = props.currentUser.userData.auth_method === 'microsoft_azure';

  return (
    <div className="edit-profile">
      <div className="edit-profile-title-container">
        <p className="edit-profile-title">My Account</p>
      </div>
      <div className="edit-profile-block-container">
        <div className={'flex-one'} />
        <div className={'edit-profile-inner-container'}>
          <EditUserProfile location={props.location} />
        </div>
        <div className={'edit-profile-sidemenu-container'}>
          <div>
            <p className={'edit-profile-sidemenu-label'}>Security</p>
            {!isMicrosoftAzureUser ? (
              <>
                <Link to={'/existing-account?change-password=true'}>
                  <p className={'edit-profile-sidemenu-button'}>Change password</p>
                </Link>

                <Link to={'/existing-account?change-security=true'}>
                  <p className={'edit-profile-sidemenu-button'}>Change security section</p>
                </Link>
              </>
            ) : null}
            <Link onClick={handleSignOut}>
              <p className={'edit-profile-sidemenu-button'}>Sign Out</p>
            </Link>
          </div>

          <div className={'flex-one'} />

          <div>
            <p className={'edit-profile-sidemenu-label'}>Legal</p>
            <Link to={'/privacy-policy'}>
              <p className={'edit-profile-sidemenu-button'}>Privacy Policy</p>
            </Link>
            <Link to={'/privacy-terms'}>
              <p className={'edit-profile-sidemenu-button'}>Terms and conditions</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

const EditProfile = (props) => {
  const account = useSelector((state) => state.account);
  const currentUser = useSelector((state) => state.currentUser);
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <EditProfileComponent
      {...props}
      account={account}
      currentUser={currentUser}
      handleLogout={handleLogout}
    />
  );
};

export default EditProfile;